import { optionSchema } from '@/common/schemas/option.schema'
import { z } from 'zod'

export const createScrapRuleSchema = z.object({
  display_name: z.string({ message: 'Campo obrigatório' }).min(3, { message: 'Tamanho minimo: 3 characteres' }).max(64, { message: 'Tamanho máximo: 64 characteres' }),
  equipment_category_ids: z.array(optionSchema).optional(),
  branch_ids: z.array(optionSchema).optional(),
  manufacturer_ids: z.array(optionSchema).optional(),
  equipment_model_ids: z.array(optionSchema).optional(),
  equipment_ids: z.array(optionSchema).optional(),
  maximum_mileage_condition: z.string().optional(),
  maximum_usage_hours_condition: z.string().optional(),
  maximum_usage_time_in_years_condition: z.string().optional(),

  has_mileage: z.boolean().optional(),
  has_hours: z.boolean().optional(),
  has_years: z.boolean().optional(),
})

export type CreateScrapRuleSchema = z.infer<typeof createScrapRuleSchema>
